const state = ({
// refresh variables
  refreshing: false,
  registration: null,
  updateExists: false,
})

const getters = {

}

const mutations = {
  // Store the SW registration so we can send it a message
  // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
  // To alert the user there is an update they need to refresh for
  updateAvailable (state, event) {
    console.log('updateAvailable')
    state.registration = event.detail
    state.updateExists = true
  },
}

const actions = {
  initEvents ({ state, dispatch, commit }) {
    document.addEventListener('swUpdated', (event) => commit('updateAvailable', event), { once: true })

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('controllerchange')
      if (state.refreshing) return
      state.refreshing = true
      // Here the actual reload of the page occurs
      window.location.reload()
    })
  },

  // Called when the user accepts the update
  refreshApp ({ state }) {
    console.log('refreshApp')
    state.updateExists = false
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (!state.registration || !state.registration.waiting) return
    // send message to SW to skip the waiting and activate the new SW
    state.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
